import styled from 'styled-components';
import { ifProp, palette, theme } from 'styled-tools';

import { CheckSimple } from '@calm-web/icons';

import { units } from '../../utils/spacing';
import { fontSize, FontSizes } from '../../utils/typography';
import { PaletteColor } from '../ThemeProvider';

export const ListItem = styled.div<{ $noItemMargin?: boolean; $isInactive?: boolean }>`
	opacity: ${ifProp('$isInactive', 0.5, 1)};
	display: flex;
	justify-content: space-between;
	margin-bottom: ${ifProp('$noItemMargin', '', units(2))};
	min-height: ${theme('buttons.minHeight')};
`;

export const ListItemText = styled.p<{ $condensed?: boolean }>`
	margin: ${units(0, 1, 0, 2)};
	${ifProp('$condensed', fontSize(FontSizes.sm))};
`;

export const IconWrapper = styled.div<{
	$iconBackgroundColor?: PaletteColor;
	$iconBorderColor: PaletteColor;
	$iconBackgroundAlpha?: number;
	$condensed?: boolean;
}>`
	backdrop-filter: blur(${units(0.75)});
	padding: ${ifProp('$condensed', units(0.5), units(1))};
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;

	svg {
		height: ${units(3)};
		width: ${units(3)};

		path {
			fill: ${palette('white')};
			height: ${units(3)};
			width: ${units(3)};
		}
	}

	background: ${props =>
		props.$iconBackgroundColor
			? palette(props.$iconBackgroundColor)
			: `rgba(0, 0, 0, ${props.$iconBackgroundAlpha ?? '0.3'})`};

	border: 2px solid ${props => palette(props.$iconBorderColor)};
`;

export const IconAndTextWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const SimpleCheckIcon = styled(CheckSimple)`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 28px;
	width: 28px;
	margin: auto ${units(1.5)};
`;
